import { render, staticRenderFns } from "./RiderOrders.vue?vue&type=template&id=b38efe88"
import script from "./RiderOrders.vue?vue&type=script&lang=js"
export * from "./RiderOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports